(function(){
  'use strict';

  /* ---------- Rules modal ----------
     The header no longer changes appearance on scroll — it is opaque cream at
     rest now, like magnumsupps.com — so the old scroll listener that toggled
     .is-stuck is gone with it.

     Every "Official Rules" affordance on the page (header button, the one
     inside the eligibility checkbox, the footer) carries data-rules and opens
     this same dialog. None of them navigate anywhere. */
  var rulesModal   = document.getElementById('rulesModal');
  var rulesClose   = document.getElementById('rulesClose');
  var rulesOpener  = null;

  function openRules(e){
    e.preventDefault();
    rulesOpener = e.currentTarget;
    if (typeof rulesModal.showModal === 'function'){
      rulesModal.showModal();
    } else {
      /* No <dialog> support: fall back to the plain open attribute so the
         rules are still readable rather than silently unreachable. */
      rulesModal.setAttribute('open','');
    }
    /* showModal() blocks interaction behind the dialog but does not reliably
       stop the page itself from scrolling under it. */
    document.body.style.overflow = 'hidden';
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-rules]'), function(el){
    el.addEventListener('click', openRules);
  });

  rulesClose.addEventListener('click', function(){ rulesModal.close(); });

  /* Clicking the backdrop closes. The dialog's own padding is zero and all
     content sits in child elements, so a target of the dialog itself can only
     be the area outside the panel. */
  rulesModal.addEventListener('click', function(e){
    if (e.target === rulesModal) rulesModal.close();
  });

  /* Fires for the close button, the backdrop and Esc alike, so scroll release
     and focus restoration live in one place. */
  rulesModal.addEventListener('close', function(){
    document.body.style.overflow = '';
    if (rulesOpener && typeof rulesOpener.focus === 'function') rulesOpener.focus();
    rulesOpener = null;
  });

  /* ---------- The gate ---------- */
  var form       = document.getElementById('gateForm');
  var emailField = document.getElementById('emailField');
  var email      = document.getElementById('email');
  var emailErr   = document.getElementById('emailErr');
  var emailErrTx = document.getElementById('emailErrText');
  var checks     = document.getElementById('checks');
  var eligible   = document.getElementById('eligible');
  var eligErr    = document.getElementById('eligibleErr');
  var marketing  = document.getElementById('marketing');
  /* Renamed from 'company': that name/label got filled by password managers and
     browser identity autofill for REAL entrants, which sent them down the bot path
     below and silently discarded their submission. Must match the id in
     templates/page.name-our-protein.liquid. */
  var honeypot   = document.getElementById('contest_ref_code');
  var btn        = document.getElementById('gateBtn');
  var note       = document.getElementById('gateNote');
  var sent       = document.getElementById('sentPanel');

  /* ---------- Contest window ----------
     Two gates enforce the Contest Period, and both are needed.

     The Liquid gate in the template is primary, but Shopify serves these pages
     from a full-page cache: `now` is evaluated when the page was RENDERED, not
     when it is viewed, so a page rendered inside the window can still be handed
     to someone after it closes. This is the view-time re-check.

     Bounds come from window.MAGNUM_CONTEST.window (injected by layout/contest.liquid
     from snippets/contest-window.liquid — one source of truth for the dates).

     Missing/!malformed config FAILS OPEN. The Liquid gate is still enforcing, and a
     broken theme setting must never be able to silently shut the whole contest. */
  function contestState(){
    var w = (window.MAGNUM_CONTEST && window.MAGNUM_CONTEST.window) || null;
    if (!w || !w.opensAt || !w.closesAt) return 'open';
    var now = Math.floor(Date.now() / 1000);
    if (now < w.opensAt)  return 'before';
    if (now > w.closesAt) return 'after';
    return 'open';
  }

  /* Replaces the form with the same notice the template would have rendered.
     Static markup only — nothing here interpolates user input. */
  function lockOutOfWindow(state){
    if (form) form.style.display = 'none';
    if (sent) sent.classList.remove('is-on');

    var n = document.getElementById('gateWindowNotice');
    if (!n){
      n = document.createElement('div');
      n.id = 'gateWindowNotice';
      n.className = 'sent';
      n.setAttribute('role', 'status');
      /* Focusable so the message below can be moved to, not just announced. */
      n.setAttribute('tabindex', '-1');

      /* Insert EMPTY, then fill. A role="status" live region that already has
         content when it enters the DOM is not reliably announced — assistive
         tech watches for mutations, and arriving pre-populated is not one. */
      if (form && form.parentNode) form.parentNode.insertBefore(n, form);

      /* Static literals only — nothing here interpolates user input.
         These date strings are duplicated from snippets/contest-window.liquid;
         see the maintenance list in that file before changing the dates. */
      n.innerHTML = (state === 'before')
        ? '<h2 class="gate__ask">Entries open August 7, 2026 at 1:00:00pm ET.</h2>' +
          '<p>Come back then to get your entry link. Nothing to do until it opens.</p>'
        : '<h2 class="gate__ask">Entries are closed.</h2>' +
          '<p>This contest closed on August 21, 2026 at 12:59:59pm ET. Thanks to everyone ' +
          'who entered — the winner is contacted by email.</p>';
    }
    n.classList.add('is-on');

    /* On the submit-time path the form is hidden out from under the focused
       button, which would otherwise drop focus to <body> with no explanation. */
    if (typeof n.focus === 'function') n.focus();
  }

  /* Outside the window the template renders the notice INSTEAD of the form, so
     every element looked up above is null. Stop here rather than letting the
     first `email.value` throw — a TypeError would also kill the rules modal
     wired up above, leaving the Official Rules unreachable. */
  if (!form){
    if (contestState() !== 'open') lockOutOfWindow(contestState());
    return;
  }

  /* Cache-stale render: server said open, the clock disagrees. */
  if (contestState() !== 'open') lockOutOfWindow(contestState());

  /* Deliberately loose. Anything stricter starts rejecting real addresses
     (plus-tags, new TLDs, unicode locals); the verification email is the
     actual validator. */
  var RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function emailOK(){ return RE.test(email.value.trim()); }
  function ready(){ return emailOK() && eligible.checked; }

  /* The button stays focusable and keeps aria-disabled rather than taking the
     `disabled` attribute, so a keyboard user can reach it and be told what is
     missing instead of tabbing past a dead control. */
  function sync(){
    var ok = ready();
    btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
    if (ok){
      /* Was "We'll send the link straight away." — that is no longer true. Measured
         delivery on this flow ran to ~13 minutes, so the old line set an expectation
         the send cannot meet and drives people to abandon or re-submit. */
      note.textContent = 'THE EMAIL WITH LINK MAY TAKE A FEW MINUTES. BE PATIENT.';
    } else if (!emailOK() && !eligible.checked){
      note.textContent = 'Enter your email and tick the eligibility confirmation to continue.';
    } else if (!emailOK()){
      note.textContent = 'Enter your email to continue.';
    } else {
      note.textContent = 'Tick the eligibility confirmation to continue.';
    }
  }

  function showErr(field, err, on, msg){
    if (msg && emailErrTx && err === emailErr) emailErrTx.textContent = msg;
    err.classList.toggle('is-on', on);
    if (field) field.classList.toggle('has-err', on);
  }

  [email, eligible].forEach(function(el){
    el.addEventListener('input', sync);
    el.addEventListener('change', sync);
  });
  /* Clear an error the moment the user fixes it, but never raise a new one
     mid-typing — errors only appear on submit or on blur. */
  email.addEventListener('input', function(){
    if (emailOK()) showErr(emailField, emailErr, false);
  });
  email.addEventListener('blur', function(){
    if (email.value.trim() !== '' && !emailOK()){
      showErr(emailField, emailErr, true, 'That doesn’t look like a complete email address.');
    }
  });
  eligible.addEventListener('change', function(){
    if (eligible.checked) showErr(checks, eligErr, false);
  });

  form.addEventListener('submit', function(e){
    e.preventDefault();

    /* Re-check at SUBMIT time, not just at load. A page left open across the
       closing moment would otherwise still post an entry that cannot be honoured. */
    var state = contestState();
    if (state !== 'open'){ lockOutOfWindow(state); return; }

    /* Bot filled the hidden field: pretend it worked, send nothing.

       Guarded with `honeypot &&` deliberately. Reading .value off a missing element
       throws, and a throw HERE kills the whole submit handler — the button would go
       dead for every entrant. If the trap markup is ever renamed or removed without
       updating this file, we lose spam filtering, which is survivable; we must not
       lose the form. The warn makes this path visible in the console, because nothing
       else about it is observable: swapToSent() shows success either way and no
       network request is made. */
    if (honeypot && honeypot.value !== ''){
      if (window.console && console.warn) {
        console.warn('[contest-gate] spam trap tripped - submission discarded, no event sent.');
      }
      swapToSent();
      return;
    }

    var badEmail = !emailOK();
    var badElig  = !eligible.checked;

    showErr(emailField, emailErr, badEmail,
      email.value.trim() === ''
        ? 'Enter the email address you want your entry link sent to.'
        : 'That doesn’t look like a complete email address.');
    showErr(checks, eligErr, badElig);

    if (badEmail){ email.focus(); return; }
    if (badElig){ eligible.focus(); return; }

    /* --------------------------------------------------------------------
       Klaviyo (public client API — the company ID is a public key and is safe
       in the storefront). Two calls, both fire-and-forget:

         1. /client/subscriptions/  subscribes to the contest list. The gate copy
            ("we'll send the link") is the express consent for THAT email. The
            separate marketing tickbox is recorded as a profile property, not as
            consent to a marketing list.
         2. /client/events/         fires the gate metric so the flow that emails
            the single-use entry link can trigger.

       swapToSent() runs IMMEDIATELY and unconditionally, before either promise
       settles. That is deliberate on two counts: a Klaviyo outage must never
       block a real entrant, and the panel must look identical whether or not the
       address has already entered — otherwise this page becomes a way to test who
       is on the list.
       -------------------------------------------------------------------- */
    /* try/catch, not just .catch(): a SYNCHRONOUS throw (missing fetch, CSP
       connect-src rejection surfacing as a constructor error) would escape the submit
       handler and swapToSent() would never run, leaving a dead button. */
    try { klSubmit(email.value.trim().toLowerCase(), marketing.checked); } catch (e) {}
    swapToSent();
  });

  /* ---------- Klaviyo ---------- */
  var CFG  = (window.MAGNUM_CONTEST && window.MAGNUM_CONTEST.klaviyo) || {};
  var REV  = CFG.revision || '2024-10-15';

  function klReady(){ return !!(CFG.enabled && CFG.companyId && CFG.listId); }

  function klPost(path, payload){
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(CFG.companyId), {
      method : 'POST',
      headers: { 'content-type':'application/json', 'revision': REV },
      body   : JSON.stringify(payload)
    }).then(function(r){ return r.status === 202; });
  }

  function klSubmit(addr, optedIn){
    if (!CFG.enabled || !CFG.companyId || !addr) return;

    /* ---- EVENT: ALWAYS. This is the contest's critical path. ----
       Klaviyo bot-protects /client/subscriptions/ but NOT /client/events/. A real
       human submitting from a real browser had their SUBSCRIPTION suppressed as
       BOT_PROTECTION one second after this exact event landed cleanly. So the
       entry-link flow triggers on this metric and never on a list join. */
    klPost('events', { data:{
      type:'event',
      attributes:{
        metric :{ data:{ type:'metric',  attributes:{ name: CFG.gateMetric || 'Contest Gate Submitted' } } },
        profile:{ data:{ type:'profile', attributes:{ email: addr } } },
        properties:{
          eligibility_confirmed : true,
          marketing_opt_in      : !!optedIn,
          entry_url             : (window.MAGNUM_CONTEST && window.MAGNUM_CONTEST.entryUrl || '') +
                                  '?e=' + encodeURIComponent(addr)
        }
      }
    }}).catch(function(){ return false; });

    /* ---- SUBSCRIPTION: ONLY ON EXPLICIT OPT-IN. ----
       Two independent reasons, either one sufficient:
       1. CASL — ticking the box is the only express consent for marketing. Entering
          a contest is not.
       2. Every subscribe attempt risks a BOT_PROTECTION suppression, and that
          permanently blocks ALL email to the address, contest link included. Never
          spend that risk on someone who did not ask for marketing.
       An entrant who does not tick still gets their link, because the flow keys off
       the event above. */
    if (!optedIn || !CFG.listId) return;

    klPost('subscriptions', { data:{
      type:'subscription',
      attributes:{
        custom_source:'Name Our New Protein — Contest Gate',
        profile:{ data:{ type:'profile', attributes:{
          email: addr,
          properties:{
            contest_name_our_protein_entrant : true,
            contest_eligibility_confirmed    : true,
            magnum_marketing_opt_in          : true,
            contest_signup_source            : 'name_our_protein_gate'
          }
        }}}
      },
      relationships:{ list:{ data:{ type:'list', id: CFG.listId } } }
    }}).catch(function(){ return false; });
  }

  function swapToSent(){
    form.style.display = 'none';
    sent.classList.add('is-on');
    sent.focus();
  }

  sync();
})();